import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { environment } from '../environments/environment';
//import { environment } from 'environments/environment';
//import { ErrorComponent } from './shared/error/error.component';

const AppRoutes: Routes = [

  { path: 'search-by-text', loadChildren: () => import('app/search-by-text/search-by-text.module').then(m => m.SearchByTextModule) },
  { path: 'search-by-vehicle', loadChildren: () => import('app/search-by-vehicle/search-by-vehicle.module').then(m => m.SearchByVehicleModule) },
  { path: 'search-by-specs', loadChildren: () => import('app/search-by-specs/search-by-specs.module').then(m => m.SearchBySpecsModule) },
  { path: 'search-by-brand', loadChildren: () => import('app/search-by-brand/search-by-brand.module').then(m => m.SearchByBrandModule) },
  { path: 'promotions', loadChildren: () => import('app/search-by-promotions/search-by-promotions.module').then(m => m.SearchByPromotionsModule) },
  { path: 'psi-kpa', loadChildren: () => import('app/placard-tool/placard-tool.module').then(m => m.PlacardToolModule) },

  { path: 'fastfinder/shop/search-by-vehicle/wheel-search', redirectTo: 'search-by-vehicle', pathMatch: 'full' },
  { path: 'fastfinder/shop/search-by-vehicle/tire-search', redirectTo: 'search-by-vehicle', pathMatch: 'full' },
  { path: 'fastfinder/shop/search-by-vehicle', redirectTo: 'search-by-vehicle', pathMatch: 'full' },
  { path: 'fastfinder/shop/search-by-text', redirectTo: 'search-by-text', pathMatch: 'full' },
  { path: 'fastfinder/shop/search-by-specs', redirectTo: 'search-by-specs', pathMatch: 'full' },
  { path: 'fastfinder/shop/search-by-brand', redirectTo: 'search-by-brand', pathMatch: 'full' },
  { path: 'fastfinder/shop/promotions', redirectTo: 'promotions', pathMatch: 'full' },

  { path: 'replika/alloy-wheels', loadChildren: () => import('app/search-by-vehicle/search-by-vehicle.module').then(m => m.SearchByVehicleModule) },
  { path: 'Replika/Alloy-Wheels', loadChildren: () => import('app/search-by-vehicle/search-by-vehicle.module').then(m => m.SearchByVehicleModule) },
  { path: 'braelin/alloy-wheels', loadChildren: () => import('app/search-by-vehicle/search-by-vehicle.module').then(m => m.SearchByVehicleModule) },
  { path: 'Braelin/Alloy-Wheels', loadChildren: () => import('app/search-by-vehicle/search-by-vehicle.module').then(m => m.SearchByVehicleModule) },
  { path: 'fast-hd/alloy-wheels', loadChildren: () => import('app/search-by-vehicle/search-by-vehicle.module').then(m => m.SearchByVehicleModule) },
  { path: 'Fast-HD/Alloy-Wheels', loadChildren: () => import('app/search-by-vehicle/search-by-vehicle.module').then(m => m.SearchByVehicleModule) },
  { path: 'fast-wheels/alloy-wheels', loadChildren: () => import('app/search-by-vehicle/search-by-vehicle.module').then(m => m.SearchByVehicleModule) },
  { path: 'Fast-Wheels/Alloy-Wheels', loadChildren: () => import('app/search-by-vehicle/search-by-vehicle.module').then(m => m.SearchByVehicleModule) },
  { path: 'fastco-canada/tools/tires/placard', redirectTo: 'psi-kpa', pathMatch: 'full' },

  { path: 'productionproposal', loadChildren: () => import('app/production-proposal-detail/production-proposal-detail.module').then(m => m.ProductionProposalDetailModule) },

  { path: 'fastfinder/shop', redirectTo: 'search-by-vehicle', pathMatch: 'full' },
  { path: 'fastfinder/Shop', redirectTo: 'search-by-vehicle', pathMatch: 'full' },
  { path: 'fastfinder/home', redirectTo: 'search-by-vehicle', pathMatch: 'full' },
  { path: 'fastfinder/Home', redirectTo: 'search-by-vehicle', pathMatch: 'full' },
  
  { path: '', redirectTo: 'search-by-vehicle', pathMatch: 'full' }

  //{ path: 'replika/alloy-wheels', redirectTo: 'search-by-vehicle', pathMatch: 'full' },
  //{ path: 'braelin/alloy-wheels', redirectTo: 'search-by-vehicle', pathMatch: 'full' },
  //{ path: 'fast-hd/alloy-wheels', redirectTo: 'search-by-vehicle', pathMatch: 'full' },

  //{ path: 'fastfinder/home/search-by-vehicle', redirectTo: 'search-by-vehicle', pathMatch: 'full' },
  //{ path: 'fastfinder/Home/search-by-vehicle', redirectTo: 'search-by-vehicle', pathMatch: 'full' },
  //{ path: 'fastfinder/home', redirectTo: 'search-by-vehicle', pathMatch: 'full' },
  //{ path: 'fastfinder/Home', redirectTo: 'search-by-vehicle', pathMatch: 'full' },

  //{ path: 'error', component: ErrorComponent },
  //{ path: '**', component: PageNotFoundComponent },

];

@NgModule({
  imports: [
    RouterModule.forRoot(AppRoutes, { enableTracing: environment.enableTracing })
  ],
  exports: [
    RouterModule
  ]
})
export class AppRoutingModule { }
